// extracted by mini-css-extract-plugin
module.exports = {"cardClassroom":"CardClassroom_cardClassroom__3hGDb"};